export const getAuthHeaders = async (getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently({
      authorizationParams: {
        audience: "retro-api",
        scope: "openid profile email read:images write:images read:favorites write:favorites"
      }
    });
    
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  } catch (error) {
    console.error('Error getting auth headers:', error);
    return null;
  }
}; 